import { css } from 'aphrodite';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Footer } from '../../components/Footer';
import { TopNav, TopNavLinkName } from '../../components/TopNav';
import { styleSheet } from './styles';

interface IProps extends RouteComponentProps<any> {
	activeSection?: TopNavLinkName;
	className?: string;
}

class _MainContainer extends React.PureComponent<IProps> {
	public render() {
		const { className, children, activeSection } = this.props;
		return (
			<div className={ `${ css(styleSheet.container) } main-container ${ className || '' }` }>
				<TopNav activeSection={ activeSection }/>
				{ children }
				<Footer/>
			</div>
		);
	}
}

export const MainContainer = withRouter(_MainContainer);
